module.exports = __webpack_public_path__ + "img/dag.34dd5a61.png";